import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useHistory, useParams, useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import { getOilBrandsOfType } from "utils/LaravelApi/LaravelAPI";


const containerStyle = {
    marginBottom: '40px',
    padding: '10px',
};

const itemStyle = {
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "120px", // Altura fija para mantener consistencia
    width: "100%",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    overflow: "hidden",
    transition: "transform 0.2s",
    "&:hover": {
        transform: "scale(1.03)",
    },
};

const textStyle = {
    fontFamily: "'Nunito Sans', sans-serif",
    fontWeight: 600,
    fontSize: "18px",
    textAlign: "center",
    padding: "16px",
};

const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain", // Mantiene relación de aspecto
    padding: "8px",
};

export default function BrandOilSelector() {

    const { path } = useRouteMatch();
    const { typeSlug, oilType } = useParams();
    let history = useHistory();
    const [items, setItems] = useState([]);

    useEffect(() => {
        async function go() {
            const brands = await getOilBrandsOfType(oilType);
            if (brands.success) {
                setItems(brands.data)
            }
        }
        go();
    }, []);

    const redirectTo = (item) => {
        const newPath = path
            .replace(":typeSlug", typeSlug)
            .replace(":oilType", oilType);
        history.push(`${newPath}/${item}`);
    };

    return (
        <Grid container spacing={1} style={containerStyle}>
            {items.map((item, index) => (
                <Grid item xs={3} key={index}>
                    <div
                        style={itemStyle}
                        onClick={() => redirectTo(item.nombre)}
                        role="button"
                        tabIndex={0}
                    >
                        {item.url ? (
                            <img
                                src={item.url}
                                style={imageStyle}
                            />
                        ) : (
                            <div style={textStyle}>{item.nombre}</div>
                        )}
                    </div>
                </Grid>
            ))}
        </Grid>
    );
}